// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { GridType } from "src/app/CP/shared/models/models";

export const environment = {
  // apiUrl: `http://192.168.2.15/DCMS-backend`,
  coreBaseUrl: `https://bmslogin.eskadenia.com/`,
   CustomerPortalDashboard:'https://bmslogin.eskadenia.com/',

  bundleUrl: `http://${window.location.host}/assets/`,
  production: false,


//CustomerPortalDashboard : "https://eska-cpq.der3.com:2003/api/CPAPI/api/Custom/PolicyTypes",


  HasNotificationError: true,
  //apiUrl: 'https://localhost:44307/',
  // apiUrl: 'https://eska-cpq.der3.com/cpapi/',

  // apiUrl: 'https://bmsportal.eskadenia.com/api/CPAPI/',
  apiUrl: '/api/CPAPI/',

  // apiUrl: '/api/CPAPI/',

  // apiUrl: 'http://10.191.240.10/NewCPAPI/',
  // shardSetupApiUrl: '/SharedSetupAPI/',
  // mapperUrl: "/ApiMapper/", // not used
  shardSetupApiUrl: '/api/SharedSetupApi/',
  // shardSetupApiUrl: '/api/SharedSetupApi/',

  mapperUrl: "/api/ApiMapper/",
  // mapperUrl: "/api/ApiMapper/",

  // apiUrl: 'https://bmsportal.eskadenia.com/api/CPAPI/',
  // apiUrl: 'http://10.191.240.10/NewCPAPI/',
  // shardSetupApiUrl: 'https://eska-cpq.der3.com/SharedSetupAPI/',
  // mapperUrl: "https://eska-cpq.der3.com/ApiMapper/", // not used
  // shardSetupApiUrl: 'https://bmsportal.eskadenia.com/api/SharedSetupApi/',
  // mapperUrl: "https://bmsportal.eskadenia.com/api/ApiMapper/",

  qsDateFormat: 'MM-dd-yyyy',
  DATE_FMT: 'dd/MM/yyyy',
  DATE_TIME_FMT: `dd/MM/yyyy hh:mm:ss`,
  calenderDateFormat: 'dd/mm/yy',
  imagePath: './assets/images/',
  coreApi: '/api/CoreApi/',
  // coreApi: 'https://www.der3.com/api/CoreApi/',

  logo: './assets/images/company-logo.png',
  gridType: GridType.ThreeColumns,
  webPublish: true,
  companyId: 1,
  productName: 'Customer Portal',
  downLoadReportsPath: "//172.16.0.42//GeneratedReports//",
  datatableDateFormat: 'dd/MM/yyyy',
  coreApiUrl: "https://10.10.100.110/CoreApi/",
  approvalApiUrl: 'https://localhost:44351/',
  datatableCurrencyFormat: { 'minIntegerDigits': 2, 'minFractionDigits': 2, 'maxFractionDigits': 2, 'currencyCode': '', 'display': '' },
  attachmentType: 1,
  systemId: 318,
  financialSecret: 'REIN',
  financialToken: 'e3d95de3-3742-4e59-9ab3-8fb616285128',
  financialURL: 'http://ENTERPRISE-TEST:11/EskadeniaInterface',
  enableDMSIntegration: false,
  dmsApiURL: 'http://172.16.0.42/DMSIntegrationAPI/',
  generatedReportPath: "C:\"\"inetpub\"\"wwwroot\"\"GeneratedReports",
  enableIanIntegration: true,
  isKsa: false,
  currency: "SAR",
  useGlobalLanding: true,
  globalLandingUrl: './login',
  MenuApplicationsId: [],
  flexAPIServer: 'http://webserver/Education/EskadeniaFlexAPI2/api/',
  DCMS_General_Settings: { 'applicationId': 8, 'renewproductId': '97', 'reportCode': 'ASICGPD0145', 'cancelproductId': '78', 'renewUrl': 'motor-renewals/', 'cancelUrl': 'Policy-Cancellation/', 'arrenewUrl': 'ar/إلغاء-وثيقة/', 'arcancelUrl': 'ar/تجديد-تأمين-المركبة/' },
  DCMS_Policy_Attachment: { 'applicationId': 8, 'generalkycproductId': '144', 'reportCode': 'ASICGPD0145', 'cancelproductId': '78', 'generalkycUrl': 'general-kyc/', 'cancelUrl': 'Policy-Cancellation/', 'argeneralkycUrlUrl': 'ar/إلغاء-وثيقة/', 'arcancelUrl': 'ar/تجديد-تأمين-المركبة/' },
  DCMS_Medical_Settings: { 'applicationId': 10, 'renewproductId': '97', 'cancelproductId': '78', 'renewUrl': 'medical-malpractice-quote/', 'cancelUrl': 'medical-malpractice-quote/' },
  DCMS_Travel_Settings: { 'applicationId': 8, 'renewproductId': '97', 'cancelproductId': '78', 'renewUrl': 'medical-malpractice-quote/', 'cancelUrl': 'medical-malpractice-quote/' },
  resourcesPath: './assets/i18n/',
  SMESetup: {
    'RenewProductID': 110, 'RenewStepID': '385', 'RenewURL': 'sme-renewals/', 'RenewARURL': 'تجديد-برنامج-التأمين-الصحي/',
    'AdditionProductID': 111, 'AdditionStepID': '391', 'AdditionURL': 'sme-members-addition/', 'AdditionARURL': 'التأمين-الصحي-إضافة-مشتركين/',
    'CorrectionProductID': 112, 'CorrectionStepID': '395', 'CorrectionURL': 'sme-members-correction/', 'CorrectionARURL': 'التأمين-الصحي-تعديل-بيانات-المشتركين/',
    'CancellationProductID': 113, 'CancellationStepID': '399', 'CancellationURL': 'sme-members-cancellation/', 'CancellationARURL': 'التأمين-الصحي-إلغاء-مشتركين/'
  },
  AttachmentsPath: "C:\\inetpub\\wwwroot\\SharedComponents\\SharedComponents.Web\\SharedComponentsNG\\src\\images\\stepEntryImages",
  ReadAttachmentsPath: "http://admintest611.solidarity.com.jo/CPAttacment",
  IsAuthorizedToken: false,
  ExtendSetup: { 'CancellationProductID': 128, 'CancellationURL': 'extend-visit-visa-cancellation/', 'CancellationARURL': 'إلغاء-تمديد-تأشيرة-الزيارة/' },
  DCMS_Sama_Settings: {
    'applicationId': 8, 'SubmitClaimRequestProductId': '124', 'reportCode': 'ASICGPD0145', 'ChangeCoversProductId': '127', 'SubmitClaimUrl': 'submit-a-claim-request/', 'ChangeCoversUrl': 'change-Covers/',
    'arSubmitClaimUrl': 'ar/تقديم-طلب-مطالبة/', 'arChangeCoversUrl': 'ar/تغيير-التغطيات/'
    , 'ModificationWithoutProductId': '126', 'ModificationWithoutUrl': 'modification-without-premium/',
    'arModificationWithoutUrl': 'ar/تعديل-بدون-تغيير-للأقساط/', 'CheckClaimStatusProductId': '125',
    'CheckClaimStatustUrl': 'check-claim-request-status/', 'arCheckClaimStatusUrl': 'ar/تحقق-من-حالة-طلب-المطالبة/'
  },
  Secret: 'InSuRaNcE^E$k@**'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
